import { motion } from "framer-motion";
import whatsappIcon from "@/assets/whatsapp-icon.png";
export function WhatsAppButton() {
  return <motion.a href="https://api.whatsapp.com/message/LVSHX74FFHBTI1?autoload=1&app_absent=0" target="_blank" rel="noopener noreferrer" className="fixed bottom-6 right-6 z-50 w-14 h-14 drop-shadow-lg" initial={{
    scale: 0,
    opacity: 0
  }} animate={{
    scale: 1,
    opacity: 1
  }} transition={{
    delay: 1,
    type: "spring",
    stiffness: 200
  }} whileHover={{
    scale: 1.1
  }} whileTap={{
    scale: 0.95
  }} aria-label="Contato via WhatsApp">
      <img alt="WhatsApp" className="w-full h-full object-contain" src="/lovable-uploads/94ed10bc-44e8-4da7-89ec-fbc80ff81395.png" />
    </motion.a>;
}